import { render, staticRenderFns } from "./packagesIsps.vue?vue&type=template&id=0b009e6b&"
import script from "./packagesIsps.vue?vue&type=script&lang=js&"
export * from "./packagesIsps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports